<template>
  <span class="element-fullscreen">
    <slot :fullscreen="fullscreen"
          :toggleFullscreen="toggleFullscreen"></slot>
  </span>
</template>

<script>
import fscreen from 'fscreen'
export default {
  name: 'ElementFullscreen',
  props: {
    target: {
      required: true
    },
    showConfirm: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      fullscreen: false
    }
  },
  computed: {
    targetElement: function () {
      let target = this.target
      if (typeof target === 'string') {
        return document.querySelector(target)
      } else {
        return target
      }
    }
  },
  methods: {
    toggleFullscreen () {
      if (fscreen.fullscreenEnabled) {
        if (this.fullscreen) {
          fscreen.exitFullscreen()
        } else {
          if (this.targetElement) {
            if (this.showConfirm) {
              this.$confirm('观看模式下部分功能将不能正常使用，是否继续？', '提示信息', {
                confirmButtonText: '继续',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                fscreen.requestFullscreen(this.targetElement)
              }).catch(() => {})
            } else {
              fscreen.requestFullscreen(this.targetElement)
            }
          }
        }
      } else {
        this.$message({
          message: '浏览器不支持观看模式',
          type: 'warning',
          center: true
        })
      }
    },
    handleFullscreenChange () {
      this.fullscreen = fscreen.fullscreenElement === this.targetElement
    }
  },
  mounted () {
    fscreen.addEventListener('fullscreenchange', this.handleFullscreenChange)
    this.handleFullscreenChange()
  },
  beforeDestroy () {
    fscreen.removeEventListener('fullscreenchange', this.handleFullscreenChange)
  }
}
</script>

<style lang="scss">
  .element-fullscreen {
    display: inline;
  }
</style>
